import {AppState} from '../reducer';

export const connectionIdSelector = (state: AppState): string | undefined => state.connectionReducer.connectionId;
export const connectionListSearchTermSelector = (state: AppState): string => state.connectionReducer.connectionListSearchTerm;
export const connectionListPageSelector = (state: AppState): number => state.connectionReducer.connectionListPage;
